import Home from "@/routers/Home/index"
import List from "@/components/List/index"

const routes = [
    {
        path: '/',
        component: Home,
        exact: true
    },
    {
        path: '/list',
        component: List,
        exact: true
    },
    {
        path: '/detail',
        component: List,
        exact: true
    },
]

export default routes;